export const config = {
  gameName: "Ani-Mayhem",
};
